import notify from "../../../../../Script/notify"
/**
 * @type {Number} - maximum character count for template name
 */
let maxCharacters = 25
/**
 * Regular expression pattern for allowed characters.
 * Matches any combination of uppercase letters, lowercase letters, digits, spaces, hyphens, parentheses, plus signs, ampersands, and periods.
 * @type {RegExp}
 */
const allowedCharsRegex = /^[A-Z\d\s-()+&.]*$/i

/**
 * @typedef {Object} maxNotification
 * @property {Function} close - Closes the notification.
 */

/**
 * @type {maxNotification}
 */
let maxNotification = {
  close() {},
}

/**
 * @type {invalidNotification}
 */
let invalidNotification = {
  close() {},
}
/**
 * Represents a notification object with a close method.
 * @property {Function} close - A function to close the notification.
 */
let notification = {
  close() {}, // Closes the notification.
}

export const checkMaxCharacters = (name) => {
  if (name) {
    if (name.length >= maxCharacters) {
      maxNotification.close()
      name = name.slice(0, maxCharacters)
      maxNotification = notify.info(`Template name should not be more than ${maxCharacters} characters`)
    }
  }
  return name
}
/**
 * function to check for given pattern to template name
 * @param e - to capture key event
 */
export const checkSpecialChars = (e, name) => {
  // Close any existing notifications
  invalidNotification.close()

  // Destructure the type and key properties from the event object
  let { type, key } = e

  // Check if it's a keypress event and the pressed key is not allowed
  if (type === "keypress" && !allowedCharsRegex.test(key)) {
    // Prevent the default keypress behavior if the pressed key is not allowed
    e.preventDefault()
    // Show a danger notification indicating the allowed characters
    invalidNotification = notify.danger("Only &emsp;<br/> <strong>Letters</strong>,&emsp; <br/> <Strong>Numbers</strong> and &emsp; <br/> <strong>-()+.&</strong> are allowed.")
  } else if (type === "paste") {
    // Prevent the default paste behavior
    e.preventDefault()

    // Get the pasted text from the clipboard
    let clipboardData = e.clipboardData || window.clipboardData
    let pastedText = clipboardData.getData("text/plain")

    // Set the input value to the pasted text
    name = pastedText

    setTimeout(() => {
      // Remove any characters that are not letters, spaces, or specified special characters
      let sanitizedText = pastedText.replace(new RegExp(`[^A-Z_\\-\\s\\d()+₹.]`, "gi"), "").trim()
      // Set the input value to the sanitized text
      name = sanitizedText
      name = checkMaxCharacters(name)
      // Show a danger notification indicating the allowed characters and the removed non-specified characters
      invalidNotification = notify.danger("Only &emsp;<br/> <strong>Letters</strong>,&emsp; <br/> <Strong>Numbers</strong> and &emsp; <br/> <strong>-()+.&</strong> are allowed. Removing non-specified Characters")
    }, 500)
  }
  // console.log(name)

  return name
}

/**
 * Trims the spaces from the file template name and performs validation checks.
 * Updates the file template name in the file template state.
 */
export const trimSpacesTemplateName = (name) => {
  if (name) name = name.trim() // Trim spaces from the file template name
  if (!name) {
    notification.close() //Close any excisting notification
    notification = notify.danger("Name shouldn't be empty") // Show a danger notification if the name is empty
  }
  return name
}
